<template>
  <div class="lower-limb-orthosis-base">
    <!-- Draw view -->
    <draw-view
      v-if="showDrawView"
      v-model="lowerLimb[blobProp]"
      :background-image="drawViewBgImg"
      @on-save="saveDrawView"
      @go-back="showDrawView = false"
    />

    <v-card
      v-if="!showDrawView"
      flat
      tile
    >
      <v-card-actions class="justify-space-between">
        <v-btn
          text
          @click="prev"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-item-group
          v-model="onboarding"
          class="text-center"
          mandatory
        >
          <hr>
          <v-item
            v-for="n in steps"
            :key="`btn-${n}`"
            v-slot:default="{ active, toggle }"
          >
            <v-btn
              :input-value="active"
              icon
              @click="toggle"
            >
              {{ n }}
            </v-btn>
          </v-item>
        </v-item-group>
        <v-btn
          text
          @click="next"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-actions>
      <v-window
        v-model="onboarding"
        touchless
      >
        <v-container>
          <!-- Step One -->
          <v-window-item>
            <StepOne
              :form="lowerLimb"
              @short-schematic="shortSchematic"
              @all-leg-schematic="allLegSchematic"
              @show-drawing="drawView('blob_sketch', 'schema_omi_3c.svg')"
            />
          </v-window-item>

          <!-- Step Two -->
          <v-window-item>
            <StepTwo :form="lowerLimb" />
          </v-window-item>

          <!-- Step Three -->
          <v-window-item v-if="showShortSchematic">
            <StepThree :form="lowerLimb" />
          </v-window-item>

          <!-- Step Four -->
          <v-window-item v-if="showAllLegSchematic">
            <StepFour
              :form="lowerLimb"
              @show-drawing="drawView('blob_cut_out', 'schema_omi_3b2.svg')"
            />
          </v-window-item>
        </v-container>
      </v-window>
      <div class="save-container">
        <v-btn
          class="cancel"
          @click="dialog = true"
        >
          <v-icon>mdi-close</v-icon>Annuler
        </v-btn>
        <v-btn
          class="save"
          @click="onSubmit"
        >
          <v-icon>mdi-content-save</v-icon>Enregistrer
        </v-btn>
      </div>
    </v-card>

    <!-- Confirmation dialog -->
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Annulation
        </v-card-title>
        <v-card-text>Toutes modifications seront perdues !</v-card-text>
        <v-card-actions>
          <div class="flex-grow-1" />
          <v-btn
            color="red"
            dark
            text
            @click="$router.go(-1)"
          >
            Oui
          </v-btn>
          <v-btn
            text
            color="black"
            @click="dialog = false"
          >
            Non
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import handleProducts from "@/mixins/handleProducts.js";

import DrawView from "../../components/DrawView";
import StepOne from "./components/StepOne";
import StepTwo from "./components/StepTwo";
import StepThree from "./components/StepThree";
import StepFour from "./components/StepFour";

export default {
  name: "LowerLimbOrthosisBase",
  provide() {
    return { parentValidator: this.$validator };
  },
  components: {
    DrawView,
    StepOne,
    StepTwo,
    StepThree,
    StepFour
  },
  mixins: [handleProducts],
  props: {
    projectUuid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // How many steps for this product
      steps: 3,
      onboarding: 0,
      dialog: false,

      showDrawView: false,

      showShortSchematic: false,
      showAllLegSchematic: false,

      // Dropdowns
      dropdowns: {},

      lowerLimb: JSON.parse(
        JSON.stringify(this.$store.state.lowerLimb.lowerLimb)
      ),

      blobProp: null,
      drawViewBgImg: null
    };
  },
  beforeDestroy() {
    this.$store.dispatch("lowerLimb/resetProduct");
  },
  methods: {
    // Submit product
    async onSubmit() {
      // Check if form is valid
      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        if (this.errors.items.length > 0) {
          this.errors.items.map(e => {
            const notif = {
              message: e.msg,
              type: "error"
            };
            this.$store.dispatch("notifications/add", notif);
          });
          return;
        }
      }

      // Form is valid ! Save product
      this.saveProduct(this.lowerLimb, this.projectUuid, "LOWER_LIMB_ORTHOSIS");
    },

    // Next step
    next() {
      this.onboarding =
        this.onboarding + 1 === this.length ? 0 : this.onboarding + 1;
    },

    // Previous step
    prev() {
      this.onboarding =
        this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
    },

    drawView(blobProp = null, bgImage = null) {
      if (blobProp) {
        this.blobProp = blobProp;
      }

      if (bgImage) {
        const image = require(`../../../assets/img/${bgImage}`);
        this.drawViewBgImg = image;
      }

      this.showDrawView = true;
    },

    saveDrawView() {
      this.blobProp = null;
      this.showDrawView = false;
    },

    shortSchematic() {
      this.showAllLegSchematic = false;
      this.showShortSchematic = true;
      this.onboarding = 2;
    },

    allLegSchematic() {
      this.drawSketch = "";
      this.showShortSchematic = false;
      this.showAllLegSchematic = true;
      this.onboarding = 2;
    }
  }
};
</script>
